/*-----------------------------------------------------------------
- Case Studies
-----------------------------------------------------------------*/

export default {
    categories: 'All Category',
    titles    : {
        list  : 'Case Studies',
        single: '{0}',
    },
    download_button: 'Download PDF',
    roadmap_title  : 'Case Study',
    customer       : {
        customer_name: 'Customer',
        industry     : 'Industry',
        region       : 'Region',
    },
};
